import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <h5>About IndiGalleria</h5>
                            <p>
                                IndiGalleria is a leading Online Art Gallery based in India & is open to the world for connecting
                                art and art admirers. You can browse, select and buy artwork and paintings online in few defined
                                steps.
                            </p>
                            <ul className="social">
                                <li><a href="#"><i className="bi bi-facebook"></i></a></li>
                                <li><a href="#"><i className="bi bi-twitter-x"></i></a></li>
                                <li><a href="#"><i className="bi bi-instagram"></i></a></li>
                                <li><a href="#"><i className="bi bi-youtube"></i></a></li>
                                <li><a href=""><i className="bi bi-pinterest"></i></a></li>
                            </ul>
                        </div>
                        <div className="col-md-6 ps-sm-5">
                            <h5>Usefull Links</h5>
                            <ul className="links">
                                <li><Link to={'/shippingReturns'}>Shipping & Returns</Link></li>
                                <li><Link to={'/packagingDeliveryPolicy'}>Packaging & Delivery Policy</Link></li>
                                <li><Link to={'/faqArtist'}>FAQ's For Artists</Link></li>
                                <li><Link to={'/faqBuyer'}>FAQ's For Buyers</Link></li>
                                <li><Link to={'/termsConditions'}>Terms & Conditions</Link></li>
                                <li><Link to={'/purchasePayments'}>Purchase & Payments</Link></li>
                                <li><Link to={'/shippingIndia'}>Shipping in India</Link></li>
                                <li><Link to={'/shippingOutsideIndia'}>Shipping outside India</Link></li>
                                <li><Link to={'/privacyPolicy'}>Privacy and policy</Link></li>
                                <li><Link to={'#'}>Login to My Account</Link></li>
                                <li><Link to={'#'}>Artist Registration</Link></li>
                                <li><Link to={'#'}>Buyer Registration</Link></li>
                                <li><Link to={'#'}>View Cart/Checkout</Link></li>
                                <li><Link to={'#'}>Blog</Link></li>
                                <li><Link to={'/searchTest'}>Feedback</Link></li>
                                <li><Link to={'/unsubscribe'}>UnSubscribe</Link></li>
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <h5>Contact Info</h5>
                            <p>
                                <i className="bi bi-geo-alt"></i>61-B, Pocket 6/2, Nasirpur Sector 1A Dwarka, New Delhi - 110045
                                (INDIA)
                            </p>
                            <p><i className="bi bi-telephone"></i>+91-9555511765</p>
                            <p><i className="bi bi-envelope-at"></i>info@indigalleria.com</p>
                            <p><i className="bi bi-envelope-at"></i>indigalleria@gmail.com</p>
                        </div>
                    </div>
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <span className="bi bi-c-circle"></span> 2017-2024 IndiGalleria. All rights reserved.
                            </div>
                            <div className="col-md-6 text-sm-end">
                                Developed By: <a href="" target="_blank">Heuristtic Minds</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer;